import React from 'react'
import { Row, Col, Button, Image, Badge } from 'react-bootstrap'
import { observable, reaction } from 'mobx'
import { observer } from 'mobx-react'
import {
  getGPSConfigValue,
  i18nTranslate,
  isEligibleToShowPVCVSV,
  checkEnableButton,
  currencyFormat,
  getLocaleString,
  getInventoryMessage,
  modifyAndGetAccountType,
  modifyAndGetCustomerType,
  checkCustomerTypeEligibility,
  getLiveEventStatus,
  getWebAvailableChannel,
  trackBuyItAgainEvent,
  isBundleHasDiscontinuedSubItem,
  stripCurrencySymbol,
  checkProductBackOrdered,
  getOrderHistoryBackOrderedDate,
  application,
  getLocalStorage,
  notAllowDangerousGoodsToCart,
  isFeatureEnabled,
} from 'src/utils'
import { Link } from 'react-router-dom'
import { VARIANT_NODES, convertToBoolean, APPConfig } from 'config/appConfig'
import {
  LinkWithLocale,
  Quantity,
  CommonForm,
  ImageComponent,
} from 'src/views/components'
import {
  orderHistoryContainer,
  cartContainer,
  customerContainer,
} from 'src/models'
import { getBackOrderInfoForOrderHistory } from 'src/views/components/ProductComponents/ProductSkuDetails/ProductInventory'
import { pageNames } from 'src/routes/pathParams'
import { productDeps } from 'src/deps'
import { cancellationFormInput } from './cancelFormInput'
import { approvalFormInput } from './approvalFormInput'
import { returnFormInput } from './returnFormInput'
import { schema } from './validationSchema'
import { actionState } from './fixture'
import './styles.scss'

function renderLabelValue(props) {
  const {
    className = '',
    label = '',
    value = '',
    valueAdd = '',
    dataTestId = '',
    key = '',
    dataTestIdForValue = '',
    dataTestIdForValueAdd = '',
  } = props
  const valueAddClass =
    valueAdd && valueAdd != '' && value != valueAdd ? 'strikeThrough' : ''
  return (
    <li
      data-testid={dataTestId}
      className="w-100 text-capitalize d-flex"
      key={key}>
      {label && label != '' && (
        <label className={`order-card-label m-0 ${className}`}>{label}</label>
      )}
      {value && value != '' && (
        <span
          className={`order-card-value ml-1 ${valueAddClass}`}
          data-testid={dataTestIdForValue}>
          {value}
        </span>
      )}
      {valueAdd && valueAdd != '' && value != valueAdd && (
        <span
          className="order-card-value ml-2"
          data-testid={dataTestIdForValueAdd}>
          {valueAdd}
        </span>
      )}
    </li>
  )
}

@observer
class ProductDetails extends React.Component {
  @observable isReturnSelected = false
  @observable isCancelSelected = false
  @observable count = this.props?.itemQuantity || ''
  @observable isExclusivePurchaseLimitReached = false
  @observable isDisableBuyItAgain = false
  isInventoryChecked = false

  static defaultProps = {
    name: '',
    size: '',
    color: '',
    quantity: '',
    price: '',
    image: '',
    orderId: '',
    placedDate: '',
    status: '',
  }
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.isDisableBuyItAgain = this.checkButtonDisable()
    reaction(
      () => [
        cartContainer.cartResponse,
        orderHistoryContainer.isGetOrderDetailsApiIsInProgress,
      ],
      () => {
        this.isDisableBuyItAgain = this.checkButtonDisable()
      }
    )
  }
  replaceCurrencySymbol = (price = '') => {
    const priceStr = String(price || '')
    return stripCurrencySymbol(priceStr)
  }
  getPrice = (custompriceValue = 0, options = {}) => {
    const formattedPrice =
      currencyFormat({
        price: custompriceValue,
        ...options,
      }) || ''
    const formattedCustomPrice = this.replaceCurrencySymbol(formattedPrice)
    return formattedCustomPrice
  }

  getProductURL = (itemInfo = {}) => {
    const productId =
      itemInfo.sku?.productId || itemInfo.otherProperties?.productId || ''
    const slug = itemInfo.otherProperties?.slug
    const productOrSlugId = slug ? slug : productId

    let productURL = `${pageNames.product}/${productOrSlugId}`
    if (itemInfo.otherProperties?.variantLabel) {
      const variantParameter =
        itemInfo.otherProperties?.variant || itemInfo.sku?.skuId
      productURL = `${productURL}?variant=${variantParameter}`
    }
    return productURL
  }

  renderProductDescription = () => {
    const { orderItem = {}, orderDetails = {} } = this.props || {}
    const { item = {} } = orderItem
    const { itemInfo = {}, itemFinancials = {}, itemPromotions = [] } = item
    const userRole = customerContainer.profileResponse?.userrole || ''
    const skuInfo = itemInfo.sku?.skuInfo || {}
    const isCombinedOrder =
      orderDetails?.otherproperties?.orderSource?.toLowerCase() ===
        'combined' || false
    const isSubscriptionItem =
      isCombinedOrder && itemInfo.otherProperties?.subscriptionId != null
    let price =
      itemInfo.sku?.priceInfo?.[0]?.salePrice ||
      itemFinancials?.priceInfo?.[0]?.sale ||
      itemFinancials?.orderPriceInfo?.[0]?.sale
    const isOrderHistory = this.props.isOrderHistory || 'false'
    price =
      (isOrderHistory && itemFinancials.priceInfo?.[0]?.sale) ||
      itemInfo.sku?.priceInfo?.[0]?.salePrice ||
      ''
    let discount = itemFinancials.priceInfo?.[0]?.discount || 0
    let discountedPrice = price
    if (discount < 0) {
      discountedPrice = price - Math.abs(discount) || 0
    }
    const productId =
      itemInfo.sku?.productId || itemInfo.otherProperties?.productId || ''
    const localvalue = getLocalStorage('accountType')
    const itemPV = itemFinancials.priceFacets?.PV?.PV || ''
    const itemPVDiscount = itemFinancials.priceFacets?.PV?.PVAfterDiscount || ''
    const itemCV = itemFinancials.priceFacets?.CV?.CV || ''
    const itemCVDiscount = itemFinancials.priceFacets?.CV?.CVAfterDiscount || ''
    const quantity = this.props.itemQuantity || 0
    const itemPromotion = itemFinancials.priceFacets || ''
    const isPromotion = itemPromotion ? true : false

    const propertiesName = skuInfo?.name || itemInfo.otherProperties?.name
    const isPreOrder = itemInfo.preordered || false

    const productURL = this.getProductURL(itemInfo)

    const productName = (
      <>
        <Link
          className="order-card-product-name"
          to={productURL}
          data-testid="qa-order-card-product-name">
          {propertiesName}
        </Link>
      </>
    )
    const orderItems = this.props?.orderItem || {}
    const productCount = itemInfo?.quantity || 0
    const inventory = itemInfo?.sku?.inventoryProperties || {}
    const {
      atpQty = 0,
      outOfStockThreshold = 0,
      backOrderedQty = 0,
    } = inventory

    const {
      bundleInfo = {},
      isBundleBackOrdered = false,
      singleProductBackOrderedStatus = false,
      getBundleBackOrderedInventory = {},
      backOrderDate = '',
    } = getOrderHistoryBackOrderedDate(orderItems) || {}

    const isToShowOrderPlacedBackOrderDateForOrderhistory =
      singleProductBackOrderedStatus && backOrderDate !== '' ? true : false

    const inventoryStatusView =
      (singleProductBackOrderedStatus &&
        getBackOrderInfoForOrderHistory({
          isToShowOrderPlacedBackOrderDateForOrderhistory,
          backOrderDate,
        })) ||
      ''

    const bundleBackOrdered = getBundleBackOrderedInventory?.[0] || {}
    const inventoryStatusForBundle =
      (bundleInfo?.length > 0 &&
        getBackOrderInfoForOrderHistory({
          isToShowOrderPlacedBackOrderDateForOrderhistory:
            isBundleBackOrdered &&
            bundleBackOrdered?.otherproperties?.backOrderDate !== ''
              ? true
              : false,
          backOrderDate:
            bundleBackOrdered?.otherproperties?.backOrderDate || '',
        })) ||
      ''
    const isBackOrderedOrderExists =
      singleProductBackOrderedStatus || isBundleBackOrdered
    const { availableChannels = [] } = itemInfo?.otherProperties || {}
    const isToShowErrorMessage =
      checkEnableButton(availableChannels, getWebAvailableChannel()) || false

    let inventoryStatus = ''
    if (!this.isInventoryChecked || isBackOrderedOrderExists) {
      let isCustomerEligible = false
      let customerTypeResult =
        modifyAndGetCustomerType(itemInfo?.otherProperties?.customerTypes) || ''
      let accoutTypeResult =
        modifyAndGetAccountType(
          customerContainer?.profileResponse?.accounts?.accountType
        ) || ''
      isCustomerEligible = checkCustomerTypeEligibility(
        customerTypeResult,
        accoutTypeResult
      )
      if (!isCustomerEligible)
        inventoryStatus = i18nTranslate(
          'pdp.userEligible',
          'This user is not eligible to purchase this product',
          {
            nameSpace: 'ssr-resource',
          }
        )
      else inventoryStatus = getInventoryMessage(itemInfo) || ''
      if (inventoryStatus === '') {
        inventoryStatus =
          bundleInfo?.length > 0 && isBundleBackOrdered
            ? inventoryStatusForBundle
            : singleProductBackOrderedStatus
              ? inventoryStatusView
              : ''
      }
    }
    /**
     * Checks if the current order item has a restricted SKU based on the cart,
     * and if so, sets the restrictionMessage variable to the restriction message.
     */
    const restrictionSku =
      cartContainer.getRestrictedItemData(orderItem, quantity) || {}
    let restrictionMessage = ''
    const skuId = itemInfo?.sku?.skuId || ''
    if (
      skuId !== '' &&
      restrictionSku?.skuId === skuId &&
      restrictionSku?.isForeignOrderRestricted
    ) {
      restrictionMessage = restrictionSku?.message || ''
    }
    const enableLiveEvent = convertToBoolean(getLiveEventStatus())
    const isDisablePVCVSVPrice = convertToBoolean(
      APPConfig?.getAppConfig()?.disablePVCVSVPrice
    )
    return (
      <ul className="order-card-pd-description m-0 p-0">
        {renderLabelValue({
          className: 'product-name font-weight-bold',
          i18nKey: '',
          label: productName,
          dataTestId: 'qa-product-name',
          dataTestIdForValue: 'qa-order-card-product-name-value',
        })}
        <li>
          {JSON.parse(isPreOrder) === true && !this.props.isFreeGift && (
            <Badge variant="info" className="order-product-type-label">
              {i18nTranslate('orderCard.preOrder', 'Preorder')}
            </Badge>
          )}
        </li>
        {renderLabelValue({
          className: 'product-quantity',
          label: (
            <div>
              <span
                className="order-description-wrapper"
                data-testid="qa-order-card-product-quantity">
                {i18nTranslate('orderCard.quantity', 'quantity')}
              </span>
              :
            </div>
          ),
          value: quantity,
          dataTestId: 'qa-product-quantity',
          dataTestIdForValue: 'qa-order-card-product-quantity-value',
        })}
        {!this.props.isFreeGift &&
          VARIANT_NODES.map(skuKey => {
            const value = skuInfo[skuKey]
            if (value) {
              return renderLabelValue({
                className: `product-${skuKey}`,
                key: `order-${skuKey}`,
                label: (
                  <div>
                    <span
                      className="order-description-wrapper"
                      data-testid="qa-order-card-product-sku">
                      {getLocaleString()[skuKey]}
                    </span>
                    :
                  </div>
                ),
                value: value,
                dataTestId: `qa-product-${skuKey}`,
                dataTestIdForValue: 'qa-order-card-product-sku-value',
              })
            }
            return ''
          })}

        {renderLabelValue({
          className: 'product-price',
          label: (
            <div>
              <span
                className="order-description-wrapper"
                data-testid="qa-order-card-product-price">
                {i18nTranslate('cart.price', 'Price')}
              </span>
              :
            </div>
          ),
          // currency code based on locale in order -- https://jira.skava.net/browse/SECOM-36671
          value: currencyFormat({
            price,
            // defaultLocale: this.props.locale,
          }),
          valueAdd: currencyFormat({ price: discountedPrice }),
          dataTestId: 'qa-sale-price',
          dataTestIdForValue: 'qa-order-card-product-price-value',
          dataTestIdForValueAdd: 'qa-order-card-product-discount-price',
        })}
        {isEligibleToShowPVCVSV({ accountType: localvalue }) && (
          <>
            {isPromotion &&
              renderLabelValue({
                className: 'product-pvprice',
                label: (
                  <div>
                    <span
                      className="order-description-wrapper"
                      data-testid="qa-order-card-product-pv">
                      {i18nTranslate('pdp.svprice', 'SV', {
                        nameSpace: 'ssr-resource',
                      })}
                    </span>
                    :
                  </div>
                ),
                value: this.getPrice(itemPVDiscount, { isPVCV: true }), // CX16-10507 - As per BE team confirmation, PVAfterDiscount is the latest pv price to be shown
                dataTestId: 'qa-sale-price',
                dataTestIdForValue: 'qa-order-card-product-pv-value',
              })}

            {isPromotion &&
              userRole !== 'ROLE_ACCOUNT_BUYER_ADMIN' &&
              !isDisablePVCVSVPrice &&
              renderLabelValue({
                className: 'product-cvprice',
                label: (
                  <div>
                    <span
                      className="order-description-wrapper"
                      data-testid="qa-order-card-product-cv">
                      {i18nTranslate('orderCard.cv', 'CV')}
                    </span>
                    :
                  </div>
                ),
                value: isOrderHistory
                  ? this.getPrice(itemCV, { isPVCV: true })
                  : this.getPrice(itemCVDiscount, { isPVCV: true }),
                dataTestId: 'qa-sale-price',
                dataTestIdForValue: 'qa-order-card-product-cv-value',
              })}
          </>
        )}
        {itemPromotions?.length > 0 && (
          <div className="pt-2" data-testid="qa-order-card-product-promotion">
            {itemPromotions?.map((promotion, index) => {
              const dataTestId = `qa-order-card-promotion-${index}`
              return (
                <p className="product-promotion" data-testid={dataTestId}>
                  {promotion?.otherproperties?.displayMessage ||
                    promotion?.description ||
                    promotion?.name}
                </p>
              )
            })}
          </div>
        )}
        {isSubscriptionItem && (
          <div>
            <Badge
              pill
              variant="danger"
              data-testid="qa-order-card-subscription-item">
              {i18nTranslate('orderCard.subscriptionItem', 'Subscription Item')}
            </Badge>
          </div>
        )}
        {!enableLiveEvent &&
          inventoryStatus != '' &&
          isToShowErrorMessage &&
          !orderHistoryContainer.isGetOrderDetailsApiIsInProgress && (
            <p
              className="web-inventory-danger"
              data-testid="qa-order-card-inventory-status">
              {inventoryStatus}
            </p>
          )}
        {!enableLiveEvent &&
          restrictionMessage != '' &&
          !orderHistoryContainer.isGetOrderDetailsApiIsInProgress && (
            <p
              className="web-inventory-danger"
              data-testid="qa-order-card-restriction-message">
              {restrictionMessage}
            </p>
          )}
      </ul>
    )
  }
  renderItemStatus = (bundlePdtStatus = '', bundleTrackingUrl = '') => {
    const status = bundlePdtStatus
      ? bundlePdtStatus
      : this.props.orderItem?.item?.itemInfo?.status || ''
    const orderStatus =
      this.props.orderDetails?.orderInfo?.orderDetails?.orderstatus
    const paymentType = this.props.orderDetails?.payments?.[0]?.type
    const trackingUrl = bundleTrackingUrl
      ? bundleTrackingUrl
      : this.props.orderItem?.shippingInfo?.shippingDetails?.trackingUrl ||
        'noValue'
    let statusDisplay = ''
    const enableLiveEvent = convertToBoolean(getLiveEventStatus())
    const gpsPaymentReviewOMSStatus = getGPSConfigValue(
      'GPSPaymentReviewOMSStatus'
    )?.toLowerCase()
    const arr = [
      'In_Process',
      'In_Promotion_Validation',
      'In_Inventory_Review',
      'In_Payment_Review',
      'In_Point_Payment_Review',
      'In_Promotion_Assignment',
      'In_Paypal_Payment_Review',
      'In_Venmo_Payment_Review',
      'In_Googlepay_Payment_Review',
      'In_Applepay_Payment_Review',
      'In_Loyalty_Review',
      'Ready_To_Edit',
      'Submitted_To_Fulfillment',
      'Received_By_Fulfillment',
    ]
    if (
      paymentType === 'BANKTRANSFER' &&
      orderStatus === 'In_Payment_Pending'
    ) {
      statusDisplay = i18nTranslate(
        'orderCart.paymentPending',
        'Payment Pending'
      )
    } else if (arr.includes(status)) {
      statusDisplay = i18nTranslate('orderCart.inprogress', 'In Progress')
    } else if (status === 'Canceled') {
      statusDisplay = i18nTranslate('orderCart.canceled', 'Cancelled')
    } else if (status === 'Return_Submitted') {
      statusDisplay = i18nTranslate(
        'orderCart.returnSubmitted',
        'Return Submitted'
      )
    } else if (status === 'Returned') {
      statusDisplay = i18nTranslate('orderCart.returned', 'Returned')
    } else if (status === 'Completed') {
      const enableOnlineReturnMFE =
        convertToBoolean(APPConfig?.getAppConfig()?.enableOnlineReturnMFE) ||
        false
      statusDisplay = enableOnlineReturnMFE
        ? i18nTranslate('orderSearch.completed', 'Completed')
        : (statusDisplay = i18nTranslate('orderCart.Shipped', 'Shipped'))
      // There is no shipping for Live Event so Completed is displayed
      if (enableLiveEvent) {
        statusDisplay = i18nTranslate('orderSearch.completed', 'Completed')
      }
    } else if (status === 'Invoiced' && trackingUrl === 'noValue') {
      statusDisplay = i18nTranslate('orderCart.inprogress', 'In Progress')
    } else if (status === 'Invoiced' && trackingUrl !== 'noValue') {
      statusDisplay = i18nTranslate('orderCart.Shipped', 'Shipped')
    } else if (status === 'Shipped' && trackingUrl === 'noValue') {
      statusDisplay = i18nTranslate('orderCart.inprogress', 'In Progress')
    } else if (status === 'Shipped' && trackingUrl !== 'noValue') {
      statusDisplay = i18nTranslate('orderCart.Shipped', 'Shipped')
    } else if (status === 'Ready_For_Pickup') {
      statusDisplay = i18nTranslate(
        'orderCart.readyForPickup',
        'Ready For Pickup'
      )
    } else if (status.toLowerCase() === 'created') {
      statusDisplay = i18nTranslate('orderCart.created', 'Created')
    } else if (status.toLowerCase() === 'pickedup') {
      statusDisplay = i18nTranslate('orderCart.pickedup', 'Pickedup')
    } else if (status.toLowerCase() === 'shipped') {
      statusDisplay = i18nTranslate('orderCart.Shipped', 'Shipped')
    } else if (status.toLowerCase() === 'In_Wire_Payment_Review') {
      statusDisplay = i18nTranslate('orderCart.wirePayment', 'Payment Pending')
    } else if (status.toLowerCase() === 'Wire_Payment_Confirmed') {
      statusDisplay = i18nTranslate(
        'orderCart.wirePaymentSuccess',
        'Received by fulfilment'
      )
    } else if (status.toLowerCase() === gpsPaymentReviewOMSStatus) {
      statusDisplay = i18nTranslate(
        'orderCart.paymentPending',
        'Payment Pending'
      )
    } else if (status === 'Under_Review') {
      statusDisplay = i18nTranslate('orderCart.underReview', 'Under Review')
    } else {
      statusDisplay = status
      // 'In Progress' is shown for all other cases for Live Event
      if (enableLiveEvent) {
        statusDisplay = i18nTranslate('orderCart.inprogress', 'In Progress')
      }
    }
    const statusValue =
      statusDisplay?.toLowerCase()?.replace(/ /g, '_') || 'status'
    const dataTestIdForValue = `qa-order-item-${statusValue}`

    return (
      <Col
        className={`order-card-item-status ${
          bundlePdtStatus ? '' : 'col-12 col-lg-3'
        } d-flex`}
        data-testid="qa-item-status">
        <label
          className="item-status-label font-weight-bold"
          data-testid="qa-order-item-status-label">
          {`${i18nTranslate('orderCard.statusMessage', 'Status')}:`}
        </label>
        <span
          className="item-status-value font-weight-bold ml-1"
          data-testid={dataTestIdForValue}>
          {statusDisplay}
        </span>
      </Col>
    )
  }
  handleSubmit = async (serializedData, props) => {
    const { isCancel = false, isReturn = false } = props
    const { orderId, getOrderById, orderItem = {} } = this.props || {}
    const itemId = orderItem.item?.itemInfo?.id || ''
    const orderDetails = {
      itemId,
      orderId,
    }
    const {
      cancellationReason = '',
      returnReason = '',
      others = '',
    } = serializedData
    const params = {
      quantity: this.count,
      reasonMessage: others,
    }
    if (isCancel) {
      params.reasonCode = cancellationReason
      const response = await orderHistoryContainer.cancelItem(
        orderDetails,
        params
      )
      this.isCancelSelected = false
      this.props.activeCancelReturnForm(-1)
      if (orderHistoryContainer.isSuccessResponse(response)) {
        await getOrderById()
      }
    } else if (isReturn) {
      params.reasonCode = returnReason
      const response = await orderHistoryContainer.returnItem(
        orderDetails,
        params
      )
      this.isReturnSelected = false
      this.props.activeCancelReturnForm(-1)
      if (orderHistoryContainer.isSuccessResponse(response)) {
        await getOrderById()
      }
    }
  }

  handleBuyItAgain = async () => {
    const { orderItem = {} } = this.props || {}
    const { item = {} } = orderItem
    const { itemInfo = {} } = item
    const selectedSkuData = []
    const skus = []
    const specialProduct = itemInfo.specialProducts || ''
    if (specialProduct) {
      skus.push({
        skuId: itemInfo.sku?.skuId || '',
        productId: itemInfo.sku?.productId || '',
        type: itemInfo.productType || '',
      })
      specialProduct.forEach((sku, index) => {
        skus.push({
          skuId: sku?.skuId || '',
          productId: sku?.productId || '',
          type: sku?.type || '',
          skuQuantity: sku?.skuQuantity || '',
        })
      })
      const productionBom = itemInfo?.otherProperties?.productionBom || false
      const type = cartContainer.getSpecialProductType(skus || [])
      const isPBomProduct = productDeps.isPbomProduct({
        type: type,
        properties: {
          productionBom: productionBom,
        },
      })
      const isBackOrdered = isPBomProduct
        ? itemInfo?.sku?.inventoryProperties?.backOrdered
        : itemInfo?.backordered
      selectedSkuData.push({
        quantity: this.props?.itemQuantity || '',
        isBackOrdered: isBackOrdered || false,
        skus,
        categoryId: itemInfo.otherProperties?.categoryId || '',
        isPbomProduct: isPBomProduct,
      })
    } else {
      selectedSkuData.push({
        quantity: this.props?.itemQuantity || '',
        skuId: itemInfo.sku?.skuId || '',
        isBackOrdered: itemInfo?.sku?.inventoryProperties?.backOrdered || false,
        productId: itemInfo.sku?.productId || '',
        categoryId: itemInfo.otherProperties?.categoryId || '',
      })
    }
    const response = await cartContainer.addToCart({
      cartArray: selectedSkuData,
      isCheckout: true,
      isShowToast: !isFeatureEnabled('hideBuyItAgainToast'),
    })
    if (orderHistoryContainer.isSuccessResponse(response)) {
      this.props.history.push(`${pageNames.checkout}`)
    }
    const enableLiveEvent = getLiveEventStatus()
    if (enableLiveEvent === 'true') {
      let products = []
      const { orderId } = this.props || {}
      response.forEach(item => {
        products.push({
          item_id: item?.skus?.[0]?.skuId || '',
          item_name: item?.skus?.[0]?.skuProperties?.name || '',
          item_brand: item?.skus?.[0]?.skuProperties?.brand || '',
          item_category: item?.properties?.categoryId,
          price: item?.skus?.[0]?.price || '',
          quantity: item?.quantity || '',
        })
      })
      trackBuyItAgainEvent({
        type: 'buy_it_again_order_history',
        order_id: orderId,
        items: products,
      })
      trackBuyItAgainEvent({
        type: 'purchase',
        order_id: orderId,
        items: products,
      })
    }
    return response
  }

  renderCancelReturnFormButton = () => {
    const dataTestId = this.isCancelSelected
      ? 'qa-cancel-order-button'
      : 'qa-return-order-button'
    return (
      <Col
        lg={3}
        className="form-buttons-group mt-4 d-flex flex-column p-0 py-1">
        <Button
          variant="primary"
          type="submit"
          className="my-4 w-100"
          data-testid={dataTestId}>
          {i18nTranslate('cancelOrderForm.submit', 'Confirm')}
        </Button>
        <Button
          variant="outline-secondary"
          className="w-100 mb-3"
          data-testid="qa-exit-cancel-button"
          onClick={() => {
            this.props.activeCancelReturnForm(-1)
            if (this.isCancelSelected) {
              this.isCancelSelected = false
            } else if (this.isReturnSelected) {
              this.isReturnSelected = false
            }
          }}>
          {i18nTranslate('cancelOrderForm.cancel', 'Cancel')}
        </Button>
      </Col>
    )
  }
  renderQuantity = () => {
    const quantity = this.props.itemQuantity || 0
    return (
      <div className="order-cancel-return-wrapper-quantity">
        <div className="mb-2">
          {i18nTranslate('cancelOrderForm.quantity', 'Quantity')}
        </div>
        <Quantity
          defaultValue={quantity}
          maxValue={quantity}
          minValue={1}
          onQuantityChange={count => {
            this.count = count
          }}
        />
      </div>
    )
  }
  renderReasonCode = () => {
    const allowedPatchFields = this.props.orderItem?.allowedPatchFields || []
    if (allowedPatchFields.length > 0) {
      let options = []
      switch (true) {
        case this.isCancelSelected:
          options = allowedPatchFields.find(
            name => name.actionName.toLowerCase() === actionState.cancel
          )
          break
        case this.isReturnSelected:
          options = allowedPatchFields.find(
            name => name.actionName.toLowerCase() === actionState.return
          )
      }
      const allowedInputs = options?.allowedInputs || []
      const reasonCode = allowedInputs.find(
        code => code.name.toLowerCase() === 'reasoncode'
      )
      return {
        reasonCode: reasonCode?.allowedValues || [],
        isRequired: reasonCode?.required || '',
      }
    }
    return []
  }
  renderCancelReturnOrderForm = () => {
    const form = this.isCancelSelected ? cancellationFormInput : returnFormInput
    const { reasonCode = [], isRequired = false } = this.renderReasonCode()
    return (
      <Col lg={12}>
        <CommonForm
          formTypeJson={form({
            quantityProp: this.renderQuantity(),
            reasonCode,
          })}
          schema={schema({ isRequired, isCancel: this.isCancelSelected })}
          SubmitButtonProps={this.renderCancelReturnFormButton}
          onSubmit={serializedData =>
            this.handleSubmit(serializedData, {
              isReturn: this.isReturnSelected,
              isCancel: this.isCancelSelected,
            })
          }
          hasInlineSubmitButton={false}
          classNameValue={{
            formClassName:
              'order-card-form order-card-return-form d-flex flex-wrap flex-row',
            formRowClassName: 'order-card-form-row px-0 mb-3',
          }}
        />
      </Col>
    )
  }
  checkItemStatus = () => {
    let isCancelAvailable = false
    let isReturnAvailable = false
    const itemAllowedPatchStatus =
      this.props.orderItem?.allowedPatchFields || []
    itemAllowedPatchStatus.forEach(allowedAction => {
      if (allowedAction.actionName.toLowerCase() === actionState.cancel) {
        isCancelAvailable = true
      }
      if (allowedAction.actionName.toLowerCase() === actionState.return) {
        isReturnAvailable = true
      }
    })
    return {
      isCancelAvailable,
      isReturnAvailable,
    }
  }

  renderBundleProducts(productInfo) {
    const id = productInfo?.skuId || ''
    const info = productInfo?.info || {}
    const { status = '', otherproperties = {} } = productInfo || {}
    const { name = '', size = '', image = '' } = info
    const trackingUrl = otherproperties?.trackingUrl || ''
    const formattedPrice = currencyFormat({
      price: productInfo?.price || 0,
    })
    const quantity = productInfo?.skuQuantity || 1
    const productID = productInfo?.productId || ''
    let url = productID ? `${pageNames.product}/${productID}` : ''
    if (otherproperties?.variantLabel) {
      const variantParameter = otherproperties?.slug || id
      url = `${url}?variant=${variantParameter}`
    }

    return (
      <Row className="prod-desc-wrapper d-flex w-100 justify-content-space-evenly bundle-product-tile-container">
        <Col>
          <LinkWithLocale
            to={{
              pathname: url,
            }}
            className={`prod-image-wrapper w-100 h-100`}>
            <Image
              src={image}
              alt={name}
              className={`mw-100 mh-100 prod-img`}
              data-testid="qa-user-sub-product-image"
            />
          </LinkWithLocale>
        </Col>
        <Col>
          <div className={`prod-desc-left`}>
            <LinkWithLocale
              to={{
                pathname: url,
              }}
              className={`text-decoration-none`}>
              <h3
                className="prod-desc-title text-capitalize"
                data-testid="qa-user-sub-product-name">
                {`${name}`}
              </h3>
            </LinkWithLocale>
            <p className="mb-0">{`${i18nTranslate('item', 'Item')}: ${id}`}</p>
            <p className="mb-0">{`${i18nTranslate(
              'quantity',
              'Quantity'
            )}: ${quantity}`}</p>
            {size && (
              <p className="mb-0">{`${i18nTranslate(
                'size',
                'Size'
              )} : ${size}`}</p>
            )}
            <p className="mb-0">{`${i18nTranslate(
              'price',
              'Price'
            )} : ${formattedPrice}`}</p>
          </div>
        </Col>
        {status ? (
          <Col>{this.renderItemStatus(status, trackingUrl)}</Col>
        ) : (
          <Col className="w-30" />
        )}
        {trackingUrl !== null && trackingUrl !== '' && (
          <Col noGutters className="d-flex justify-contents-center">
            <a
              href={trackingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary track-package-button w-100 px-1 ml-0 d-flex justify-content-center align-items-center"
              role="button">
              {i18nTranslate('orderCard.trackPackage', 'Track Package')}
            </a>
          </Col>
        )}
      </Row>
    )
  }

  /**
   *  Function to check Buy it again button is enabled or not
   * @date 07/12/2023
   * @returns {*} boolean
   */
  checkButtonDisable = () => {
    const nonSellableProductStatus = [
      'replacement',
      'preview product',
      'preview',
      'stopped',
      'discontinued',
      'inactive',
    ]

    const { itemInfo = {} } = this.props?.orderItem?.item
    const { specialProducts = [] } = itemInfo || {}
    const {
      availableChannels = [],
      productStatus = '',
      dangerousGoods = '',
      isExclusive = false,
    } = itemInfo.otherProperties || {}

    let customerTypeResult =
      modifyAndGetCustomerType(itemInfo.otherProperties?.customerTypes) || ''
    let accoutTypeResult =
      modifyAndGetAccountType(
        customerContainer?.profileResponse?.accounts?.accountType
      ) || ''
    const isCustomerEligible = checkCustomerTypeEligibility(
      customerTypeResult,
      accoutTypeResult
    )
    const isEnableBuyItAgain =
      checkEnableButton(availableChannels, getWebAvailableChannel()) || false

    if (isExclusive) {
      const exclusiveResponse =
        customerContainer.checkConditionsForExclusiveItems(
          [this.props?.orderItem],
          this.props.itemQuantity
        )
      if (exclusiveResponse?.not_available?.length > 0) {
        this.isExclusivePurchaseLimitReached = true
        return true
      } else {
        this.isExclusivePurchaseLimitReached = false
      }
    }
    /**
     * Checks if the item is restricted for the customer
     *
     * @returns {boolean} Whether the item is restricted
     */
    const isFORestricted = this.isForeignOrderRestricted() || false

    return (
      !isCustomerEligible ||
      !isEnableBuyItAgain ||
      nonSellableProductStatus?.includes(productStatus?.toLowerCase()) ||
      (dangerousGoods === 'true' && notAllowDangerousGoodsToCart()) ||
      isFORestricted ||
      isBundleHasDiscontinuedSubItem?.(specialProducts) ||
      false
    )
  }

  isForeignOrderRestricted = () => {
    const { itemQuantity = 1, orderItem = {} } = this.props
    const restrictionSku =
      cartContainer.getRestrictedItemData(orderItem, itemQuantity) || {}
    return restrictionSku?.isForeignOrderRestricted
  }

  renderButtonGroup = () => {
    const { isCancelAvailable, isReturnAvailable } = this.checkItemStatus()
    const trackingUrl =
      this.props.orderItem?.shippingInfo?.shippingDetails?.trackingUrl || ''
    //const { productStatus = '' } = this.props.orderItem?.item?.itemInfo || {}
    // track package button should show based on the tracking url
    const { status = '', otherProperties = {} } =
      this.props.orderItem?.item?.itemInfo || {}
    // const trackingUrl = url !== null ? url : ''

    const { availableChannels = [] } = otherProperties || {}
    const isToShowBuyItAgainButton =
      checkEnableButton(availableChannels, getWebAvailableChannel()) || false
    const enableLiveEvent = getLiveEventStatus()

    const getReturnOrCancelButton = () => {
      const { activeCancelReturnForm, index } = this.props
      switch (true) {
        case isCancelAvailable:
          return (
            <Button
              variant="outline-secondary"
              className="styled-button cancel-order-button mb-3"
              data-testid="qa-cancel-item"
              onClick={() => {
                activeCancelReturnForm(index)
                this.isCancelSelected = true
              }}>
              {i18nTranslate('orderCard.cancelItem', 'Cancel Item')}
            </Button>
          )
        case isReturnAvailable:
          return (
            <Button
              variant="outline-secondary"
              className="styled-button cancel-order-button w-100 mb-3"
              data-testid="qa-return-item"
              onClick={() => {
                activeCancelReturnForm(index)
                this.isReturnSelected = true
              }}
              disabled>
              {i18nTranslate('orderCard.returnItem', 'Return Item')}
            </Button>
          )
        default:
          return <React.Fragment />
      }
    }

    if (
      !orderHistoryContainer.isGetOrderDetailsApiIsInProgress &&
      enableLiveEvent !== 'true'
    ) {
      return (
        <Col
          lg={3}
          className="order-card-product-button-group d-flex flex-wrap">
          {trackingUrl !== null && trackingUrl !== '' && (
            <a
              href={trackingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary track-package-button w-100 mb-3 d-flex justify-content-center align-items-center"
              role="button">
              {i18nTranslate('orderCard.trackPackage', 'Track Package')}
            </a>
          )}
          {status !== 'Returned' && isToShowBuyItAgainButton && (
            <Button
              className="primary-button buy-it-again-button w-100 mb-3"
              data-testid="qa-order-item-again"
              disabled={
                this.getProductStatus()?.shouldDisableButton == true ||
                this.isDisableBuyItAgain ||
                checkProductBackOrdered()?.shouldDisableButton === false
              }
              onClick={() => {
                this.handleBuyItAgain()
              }}>
              {i18nTranslate('orderCard.buyItAgain', 'Buy It Again')}
            </Button>
          )}
          {getReturnOrCancelButton()}
        </Col>
      )
    }
    return <></>
  }

  handleApprove = () => {
    console.log('click approved happend')
  }
  handleReject = () => {
    console.log('click reject happend')
  }

  renderSubmitButton = () => {
    const size = application?.isMobile ? 'md' : 'lg'
    return (
      <Row
        noGutters
        className={`mb-2 d-flex flex-column justify-content-between m-0`}>
        <Button
          variant="success"
          className="approval-submit-button d-flex p-0 justify-content-center align-items-center"
          size={size}
          type="submit"
          data-testid="qa-approval-submit">
          {i18nTranslate('approval.submit', 'Approve')}
        </Button>
        <Button
          variant="outline-secondary"
          className="approval-reject-button d-flex p-0 mt-2 justify-content-center align-items-center"
          size={size}
          onClick={this.handleReject}
          data-testid="qa-approval-reject">
          {i18nTranslate('approval.reject', 'Reject')}
        </Button>
      </Row>
    )
  }

  renderApprovalSection = () => {
    return (
      <Col lg={12}>
        <CommonForm
          formTypeJson={approvalFormInput}
          SubmitButtonProps={this.renderSubmitButton}
          onSubmit={this.handleApprove}
          hasInlineSubmitButton={true}
          classNameValue={{
            formClassName: 'order-approval-form',
            formRowClassName: 'order-approval-form-row',
          }}
        />
      </Col>
    )
  }

  getProductStatus = () => {
    const { orderItem = {} } = this.props || {}
    const { item = {} } = orderItem
    const { itemInfo = {} } = item
    const bundleInfo = itemInfo?.specialProducts || []
    const bundleAvailable =
      bundleInfo?.map(value => {
        return value?.inventoryProperties?.available
      }) || []
    const checkIfBundleIsNotAvailable =
      bundleAvailable?.some(value => value === false) || false
    const returnValue = { shouldDisableButton: false, productStatusText: '' }
    if (itemInfo.productStatus === 'INACTIVE') {
      returnValue.shouldDisableButton = true
      returnValue.productStatusText = 'INACTIVE'
    } else if (
      itemInfo?.sku?.inventory === 'OUT OF STOCK' ||
      checkIfBundleIsNotAvailable
    ) {
      this.isInventoryChecked = true
      returnValue.shouldDisableButton = true
      returnValue.productStatusText = 'OUT OF STOCK'
    }
    return returnValue
  }

  renderProductErrorMessages = () => {
    const { productStatusText = '' } = this.getProductStatus()

    if (!orderHistoryContainer.isGetOrderDetailsApiIsInProgress) {
      return (
        <>
          {productStatusText === 'INACTIVE' && (
            <p
              className="border border-danger text-danger px-2 ml-2"
              data-testid="qa-order-item-inactive">
              {i18nTranslate(
                'subscription.searchCardUnavailable',
                'Unavailable'
              )}
            </p>
          )}
          {productStatusText === 'OUT OF STOCK' && (
            <div
              className="d-flex align-items-center ml-2 mt-2"
              data-testid="qa-order-item-out-of-stock">
              <span className="border border-danger text-danger px-3 py-1 font-weight-bold out-of-stock-order-history">
                {i18nTranslate('cart.outOfStock', 'OUT OF STOCK')}
              </span>
            </div>
          )}
          {productStatusText === 'user not eligible to purchase' && (
            <p
              className="border border-danger text-danger px-2 ml-2"
              data-testid="qa-order-item-not-eligible">
              {i18nTranslate(
                'product.userType',
                'This user is not eligible to purchase this product.'
              )}
            </p>
          )}
          {this.isExclusivePurchaseLimitReached && (
            <p
              className="border border-danger text-danger px-2 ml-2"
              data-testid="qa-order-item-limit-exceeded">
              {i18nTranslate(
                'exclusive.excedeedLimitMsg',
                'Exceeded your purchase limit for this product'
              )}
            </p>
          )}
        </>
      )
    }
    return <></>
  }

  render() {
    const { orderItem = {}, activeOrderItem, index } = this.props || {}
    const { item = {} } = orderItem
    const { itemInfo = {} } = item

    const image =
      itemInfo.sku?.skuInfo?.image || itemInfo.otherProperties?.imageURL || ''
    const subProducts = itemInfo.specialProducts || []
    const productName =
      itemInfo?.sku?.skuInfo?.name || itemInfo?.otherProperties?.name || ''
    const productURL = this.getProductURL(itemInfo)

    const isCancelReturnFormActive = activeOrderItem === index
    const itemsProductTitle = i18nTranslate(
      'orderCard.itemsProduct',
      'Items in the Special Product'
    )

    return (
      <Row
        noGutters
        className="order-card-product-wrapper w-100 justify-content-between border-bottom py-3"
        data-testid="qa-ordered-product-item-container">
        <Col lg={5} className="order-card-product-detail d-flex flex-wrap mb-3">
          <div className="product-image position-relative pr-3">
            <Link to={productURL}>
              {/* <Image
                src={image}
                alt=""
                aria-label={productName}
                onError={e => (e.target.src = imagePlaceholder)}
                className="order-product-image mw-100 mh-100 position-absolute m-auto"
              /> */}
              <ImageComponent
                testid="order-product-image "
                src={image}
                height={'100px'}
                width={'100px'}
                aria-label={productName}
              />
            </Link>
          </div>
          {this.renderProductDescription()}
        </Col>
        {(!isCancelReturnFormActive ||
          !(this.isReturnSelected || this.isCancelSelected)) &&
          !this.props.isFreeGift && (
            <>
              {this.renderItemStatus()}
              {!orderHistoryContainer.otherUsers && this.renderButtonGroup()}
              {this.renderProductErrorMessages()}
            </>
          )}
        {isCancelReturnFormActive === true &&
          this.renderCancelReturnOrderForm()}
        {subProducts && subProducts.length > 0 && (
          <div
            className="w-100 order special-products"
            data-testid="qa-user-bundle-items-container">
            <Row noGutters className="mx-auto pl-3 py-3">
              {/* <span
                className="px-2 ml-auto qa-count"
                data-testid="qa-count"></span>
              <AccordionBlock
                className="mr-auto py-0"
                textClass="text-primary"
                title={itemsProductTitle}
                dataTestId="qa-cart-view"
                isOutsideAccordion={true}>
                {subProducts.map(this.renderBundleProducts.bind(this))}
              </AccordionBlock> */}
              {subProducts.map(this.renderBundleProducts.bind(this))}
            </Row>
          </div>
        )}
      </Row>
    )
  }
}

export default ProductDetails
export { ProductDetails }
